// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"ix","logoWrapper":"iy"};